import type { HttpRequest } from '../http.js'

const openaiHost = 'api.openai.com'

export interface OpenaiRequestParams {
  host?: string
  path: string
  method?: string
  body?: Record<string, unknown>
  apiKey?: string
}

export type OpenaiRequestAPI = (params: OpenaiRequestParams) => Promise<unknown>

export function createRequestAPI(httpRequest: HttpRequest): OpenaiRequestAPI {
  return async ({ host = openaiHost, path, method = 'POST', body = {}, apiKey }) => {
    if (!apiKey) {
      throw new Error('apiKey is required for OpenAI API calls')
    }

    const options = {
      protocol: 'https' as const,
      options: {
        host,
        path,
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
        },
      },
      data: method === 'POST' || method === 'PUT' ? JSON.stringify(body) : '',
      timeout: 60000,
    }

    const resp = await httpRequest(options)

    if (resp.statusCode >= 400) {
      throw new Error(`OpenAI API error: ${resp.statusCode} - ${JSON.stringify(resp.body)}`)
    }

    return JSON.parse(resp.body)
  }
}
